import React from 'react';
import { Outlet } from 'react-router-dom';
import DashboardHeader from './DashboardHeader';
import Sidebar from './sidebar';

interface DashboardLayoutProps {
  title?: string;
  description?: string;
  breadcrumbs?: Array<{ label: string; href?: string }>;
  headerActions?: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  title,
  description,
  breadcrumbs,
  headerActions,
}) => {
  return (
    <div className="flex min-h-dvh bg-bg-primary md:h-dvh md:overflow-hidden">
      <Sidebar />

      <div className="flex flex-1 min-w-0 flex-col md:min-h-0">
        <DashboardHeader
          title={title}
          description={description}
          breadcrumbs={breadcrumbs}
          actions={headerActions}
        />
        <main className="flex-1 overflow-visible md:min-h-0 md:overflow-y-auto">
          <div className="container-main py-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
